export default __webpack_public_path__ + "static/media/cloud_brown.31ac8835.png";